<template>
  <div>
    <div role="tablist">
      
      <BookingCardFilters
        :reservas="reservas"
        :changeParentProperty="changeDataStatus"
        :path="path"
      />
      
      <div>
        <!-- {{isDataLoading}}-{{reservas.length}}-{{reservas}}   -->
        <!-- && reservas != undefined && reservas.length == 0 -->
        <p class="title" v-html="title"></p>
        <Spinner v-if="isDataLoading && reservas != undefined && reservas.length == 0" color="#fedd00" />
        <div v-else>
          <BookingCardTable
            v-if="!spinner && reservas != undefined && reservas.length > 0"
            :showUnassigned="showUnassigned"
            :reservas="reservas"
            :isBookingExpanded="isBookingExpanded"
            :showIndividualBookingsUnassigned="showIndividualBookingsUnassigned"
            :showFilteringActivityGroup="showFilteringActivityGroup"
            :groupingGroups="groupingGroups"
            :filterActivity="filterActivity"
            :showBuses="showBuses"
            :idBus="idBus"
            :path="path"
          />
          <h2 v-else style="text-align: center;">No hay datos a mostrar</h2>
        </div>
        
      </div>
     
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import CountryFlag from "vue-country-flag";
import { EventBus } from "../../../../EventBus";
import BookingCardTable from "./BookingCardTable";
import BookingCardFilters from "./BookingCardFilters";
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import BookingLoader from "../BookingUtils/BookingLoader";


export default {
  name: "BookingCard",
  props: [
    "idBus",
  ],
  components: {
    CountryFlag,
    BookingCardFilters,
    BookingCardTable,
    Spinner,
    BookingLoader,
  },
  data() {
    return {
      visible: true,
      showUnassigned: false,
      spinner: false,
      isBookingExpanded: true,
      showIndividualBookingsUnassigned: false, 
      showBuses: false,
      showFilteringActivityGroup: 0,
      groupingGroups: 'common_id',
      filterActivity: "0",
    };
  },
  mounted() {
    EventBus.$on("BookingsAreLoaded", this.onBookingsLoaded.bind(this));
    this.$store.dispatch("activityDurationTypes/retrieveActivityDurationTypes")
  },
  methods: {
    changeDataStatus(propertyName, value) {
      this[propertyName] = value;
    },
    onBookingsLoaded(areLoaded) {
      this.spinner = !areLoaded;
    },
  },
  computed: {
    ...mapGetters(["activeTab"]),
    ...mapGetters(["activeOption"]),
    ...mapGetters(["bookingsByActivity"]),
    ...mapGetters(["bookingsByExcursionBus"]),
    ...mapGetters(["bookingsByPickupBus"]),
    ...mapGetters(["bookingsByStop"]),
    ...mapGetters(['isBookingLoading', 'isGeneralLoading', 'isDataLoading']),
    path() {
      if ( this.$route.path == "/app/excursiones/excursiones" )
        return "Excursion"
      else if ( this.$route.path == "/app/excursiones/pickups" )
        return "Pickup"
      else if ( this.$route.path == "/app/excursiones/returns" )
        return "Return"
    },
    reservas() {
      if (this.activeOption == "Excursion") {
        return this.bookingsByExcursionBus;
      }
      if (this.activeOption == "Pickup") {
        return this.bookingsByPickupBus;
      }
      if (this.activeOption == "Stop") {
        return this.bookingsByStop;
      }
      if (this.activeOption == "Activity") {
        return this.bookingsByActivity;
      } 
      if ( this.activeOption == "NoService" ) {
        return this.bookingsByActivity
      }
    },
    title() {
      if ( this.activeTab == 'Excursions') {
        if ( this.activeOption == 'Activity') {
          return 'Reservas clasificadas por actividad'
        } else if ( this.activeOption == 'Excursion') {
          return 'Composición de los buses de <strong>excursión</strong>'
        } else if ( this.activeOption == 'NoService') {
          return 'Reservas sin servicio de bus de excursión'
        }
      } else if ( this.activeTab == 'Pickups') {
        if ( this.activeOption == 'Stop') {
          return 'Reservas por parada'
        } else if (this.activeOption == 'Excursion') {
          return 'Composición de los buses de <strong>excursión</strong>'
        } else if (this.activeOption == 'Pickup') {
          return 'Composición de los buses de <strong>recogida</strong>'
        } else if ( this.activeOption == 'NoService') {
          return 'Reservas sin servicio de bus de recogida'
        }
      } else if ( this.activeTab == 'Unassigned') {
        return 'Reservas sin asignación de parada'
      } else if ( this.activeTab == 'Orphan') {
        return 'Reservas sin grupo asignado'
      }
    }
  },
};
</script>

<style scoped>
button:hover {
  text-decoration: none;
  color: rgb(83, 79, 79);
}
button:focus {
  color: rgb(83, 79, 79);
}
.title {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 10px;
    padding-bottom: 10px;
}
</style>
